<div class="container">
    <!-- <h2 class="acess_ban"><i class="fa fa-lock"></i></h2> -->
    <h3>Business Post Description</h3>
    <div>
        <p>{{text}}</p>
    </div>
</div>